<template >
    <div>
        <section id="contact-us" class="bg-contact about section">
            <div class="container">
                <div class="row">
                    <div class="mb-5">
                        <img src="../assets/image/icon.webp" width="50">
                        <div class="titulo-sobre">
                            {{ translateAll.enter }} <span class="texto-destaque">{{ translateAll.contact }}</span>
                        </div>
                        <div class="separator"></div>
                        <div class="text-card text-center">
                            <span class="mb-3">
                                {{ translateAll.visit_us }}
                            </span>
                        </div>
                    </div>

                    <div class="sub-title col-lg-6 text-start" >
                        <h3>{{ translateAll.contact_details }}</h3>
                     
                        <div class="contact-details">
                            <div class="con-info"> 
                                <i class="tf-map-pin"></i>
                                <b-icon icon="geo-alt-fill" aria-hidden="true" class="icon-contact"></b-icon> <span>Rua Fioravante Milanez, 82 – sala 402<br>Centro de Canoas - RS</span>
                            </div>
                            <div class="separador"></div>

                            <div class="con-info">
                                <i class="tf-ion-ios-telephone-outline"></i>
                                <b-icon icon="telephone" aria-hidden="true" class="icon-contact"></b-icon> <span>{{ translateAll.phone }}: +55 (51) 9 8022-0040 </span>
                            </div>

                            <div class="con-info">
                                <i class="tf-ion-ios-email-outline"></i>
                                <b-icon icon="envelope" aria-hidden="true" class="icon-contact"></b-icon>Email: <a class="email-contact" href="mailto:golombiodonto@gmail.com">golombiodonto@gmail.com</a>
                            </div>
                        </div>
                    </div>
         
                    <div class="contact-form col-lg-6 mt-4 mt-lg-0 wow fadeInUp" data-wow-duration="500ms" data-wow-delay="300ms">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2445.2308243204893!2d-51.182345015884415!3d-29.91963944213353!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95197aa76bbabf7d%3A0x2ac44c03f0328e97!2sR.%20Fioravante%20Milan%C3%AAs%2C%2082%20-%20sala%20402%20-%20Centro%2C%20Canoas%20-%20RS%2C%2092010-010!5e0!3m2!1spt-BR!2sbr!4v1720326524362!5m2!1spt-BR!2sbr" width="100%" height="100%" style="border:0; border-radius: 10px;"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                </div>
            </div>

        </section>
        <section class=" space-section space-site">
            <div class="d-flex justify-content-start ">
                <div class="col-lg-12 d-flex flex-wrap justify-content-evenly footer-section">
                    <a class="navbar-brand logo" href="/">
                        <span>Legacy</span> 
                        &copy; 2017
                    </a>
                    
                </div>
            </div>
        </section>
    </div>
</template>
<script>

import {eventBus} from '@/main'
import Pt from "@/language/Pt.json";
import En from "@/language/En.json";
import Es from "@/language/Es.json";

export default {

    data() {
        return {
            translateAll: [],
            translateEn: [],
            getName: '',
            getEmail: '',
            getNumber: '',
            getMessage: '',

        }
    },
    created() {
        let languageSite = new URLSearchParams(window.location.search).get("language");

        if(languageSite === "pt") {
            this.translateAll = Pt[0];

        } else if(languageSite === "en") {
            this.translateAll = En[0];

        } else if(languageSite === "es") {
            this.translateAll = Es[0];

        } else {
            this.translateAll = Pt[0];
        }

        eventBus.$on("pt", (pt) => {
            this.translateAll = pt;
        });
        eventBus.$on("en", (en) => {
            this.translateAll = en;
        });
        eventBus.$on("es", (es) => {
            this.translateAll = es;
        });

    },
}
</script>
<style >
    .bg-contact{
        background-color: #222323;
        padding: 5rem 0 5rem 0;
        font-family: "Mulish";
    }

    .sub-title h3{
        font-style: italic;
        padding: 0 0 1.5rem;
        font-family: "Mulish";
    }
    .separador{
        border: 1px solid #e1c571;
        width: 15%;
        margin: .5rem 0 1rem;
    }
    .icon-contact{
        color: #e1c571;
        margin: 0 1rem 0 0 ;
    }
    .email-contact{
        color: white;
        text-decoration: none;
    }
    .email-contact:hover{
        color: #eda365;
    }
    .con-info{
        font-size: 16px;
        margin: 8px 0;
    }
</style>